import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[xmAriaCheckbox]',
    standalone: false
})
export class XmCheckboxDirective implements AfterViewInit {
    @Input() public isInputChecked: boolean;
    public isAriaChecked: boolean = false;

    private el: ElementRef;
    private renderer: Renderer2;

    constructor(el: ElementRef,  renderer: Renderer2) {
        this.el = el;
        this.renderer = renderer;
    }

    public ngAfterViewInit(): void {
        this.updateAriaChecked();
    }

    @HostListener('change', ['$event'])
    public onChange(event: Event): void {
        const checkbox: HTMLInputElement = <HTMLInputElement> event.target;
        this.isAriaChecked = this.isInputChecked ? !this.isInputChecked : checkbox.checked;
        this.updateAriaChecked();
    }

    private updateAriaChecked(): void {
        this.renderer.setAttribute(this.el.nativeElement, 'aria-checked', this.isAriaChecked ? 'true' : 'false');
    }
}
